var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dyte-meeting',{ref:_vm.meetingId})
}
var staticRenderFns = []

export { render, staticRenderFns }